module.exports = __webpack_public_path__ + "static/media/SVGFees.0cf271e2.svg";